<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 15" width="24" height="24">
	<path class="fillDefault fillActive" d="M7,13.3c3.2,0,5.8-2.6,5.8-5.8c0-3.2-2.6-5.8-5.8-5.8c-3.2,0-5.8,2.6-5.8,5.8C1.2,10.7,3.8,13.3,7,13.3z
	 M14,7.5c0,3.9-3.1,7-7,7c-3.9,0-7-3.1-7-7c0-3.9,3.1-7,7-7C10.9,0.5,14,3.6,14,7.5z" />
	<path class="fillDefault fillActive" d="M7,4.3c0.2,0,0.4,0.1,0.6,0.2c0.2,0.2,0.2,0.4,0.2,0.6v2.4c0,0.2-0.1,0.4-0.2,0.6C7.4,8.2,7.2,8.3,7,8.3
		c-0.2,0-0.4-0.1-0.6-0.2C6.3,7.9,6.2,7.7,6.2,7.5V5.1c0-0.2,0.1-0.4,0.2-0.6C6.6,4.4,6.8,4.3,7,4.3z M7.8,9.9c0-0.2,0-0.3-0.1-0.4
		C7.6,9.3,7.5,9.2,7.3,9.2C7.2,9.1,7,9.1,6.8,9.1c-0.2,0-0.3,0.1-0.4,0.2C6.3,9.4,6.2,9.6,6.2,9.7c0,0.2,0,0.3,0,0.5
		c0.1,0.1,0.2,0.3,0.3,0.4c0.1,0.1,0.3,0.1,0.4,0.1c0.2,0,0.4-0.1,0.6-0.2S7.8,10.1,7.8,9.9z" />

</svg>